<template>
  <div>
    <custom-actions title="历史预约">
      <el-form :model="searchForm2" ref="searchForm2" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="plateNumber">
          <el-input v-model="searchForm2.plateNumber" placeholder="请输入车牌号" />
        </el-form-item>
        <el-form-item prop="ygType">
          <el-select v-model="searchForm2.ygType" :clearable="true" placeholder="请选择预约类型">
            <el-option label="出库" value="A"></el-option>
            <el-option label="入库" value="B"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="planType">
          <el-select v-model="searchForm2.planType" :clearable="true" placeholder="请选择计划类型">
            <el-option :key="index" :label="item[1]" :value="item[0]"
              v-for="(item, index) of Array.from(planTypeMap)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reservationStatus">
          <el-select clearable v-model="searchForm2.reservationStatus" placeholder="请选择状态">
            <el-option label="未预约" value="1"></el-option>
            <el-option label="已签到" value="3"></el-option>
            <el-option label="装货中" value="4"></el-option>
            <el-option label="已装货" value="5"></el-option>
            <el-option label="已完成" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('2')">查询</el-button>
          <el-button @click="onReset('searchForm2')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
    <el-card class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData2">
        <el-table-column min-width="120" label="关联客户" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="关联工单号" prop="orderNumber"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="plateNumber"></el-table-column>
        <el-table-column min-width="120" label="挂车号" prop="vehicleGph"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="120" label="司机手机号" prop="driverPhone"></el-table-column>
        <el-table-column min-width="160" label="司机身份证" prop="driverId"></el-table-column>
        <el-table-column min-width="120" label="车辆类型" prop="vehicleType">
          <template v-slot="{ row }">
            {{ vehicleTypeMap.get(row.vehicleType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="计划数量" prop="plannedNum">
          <template v-slot="{ row }">
            <div style="display: flex;;align-items: center;">
              <el-button type="text" @click="loadGgList(row.planId)">{{ row.plannedNum || '--' }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="可预约时间段" prop="">
          <template v-slot="{ row }">
            {{ row.vehicleDateStart }} 至 {{ row.vehicleDateEnd || '--' }}
          </template>
        </el-table-column>

        <el-table-column width="280" label="操作" fixed="right">
          <template v-slot="{ row }">
            <plan-document-actions :plan-id="row.planId" :status="row.reservationStatus" :yg-type="row.ygType" />
            <el-button type="text" @click="$router.push('/entryplan/detail?planId=' + row.planId)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/entryplan/edit?planId=' + row.planId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.planId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData2">
      </el-pagination>
    </el-card>

    <el-dialog title="入场规格清单" :visible.sync="guigeVisible" width="800px">
      <el-table size="mini" stripe border v-loading="loading" :data="planGgList">
        <el-table-column min-width="180" label="规格名称" prop="specName"></el-table-column>
        <el-table-column min-width="100" label="规格单位" prop="unit"></el-table-column>
        <el-table-column min-width="100" label="计划数量" prop="planQuantity"></el-table-column>
        <el-table-column min-width="100" label="发货数量" prop="pickupQuantity"></el-table-column>
        <el-table-column min-width="100" label="到货数量" prop="arrivalQuantity"></el-table-column>
        <el-table-column v-if="gGviewType === '2'" min-width="100" label="操作">
          <template v-slot="{ row }">
            <el-button type="text" @click="showNumber(row)">填写数量</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" v-if="gGviewType === '2'" class="dialog-footer">
        <el-button @click="guigeVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmComplete">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import PlanDocumentActions from './PlanDocumentActions.vue'
import { vehicleType, reservationStatus, arrivalStatus, isMealFormat, planType } from '@/utils/dict'
import { validNumber3 } from '@/utils/validator'
import { deepClone } from '@/utils/utils'

export default {
  components: { PlanDocumentActions },
  name: 'EntryPlanHistory',
  mixins: [keepAlive],
  data() {
    return {
      currentPickupId: '',
      ygTypeActive: 'A',
      activeName: '1',
      planTypeMap: planType,
      guigeVisible: false,
      gGviewType: '1',
      vehicleTypeMap: vehicleType,
      reservationStatusMap: reservationStatus,
      arrivalStatusMap: arrivalStatus,
      isMealFormatMap: isMealFormat,
      tableData1: [],
      planGgList: [],
      comfirmVisible: false,
      page: 1,
      total: 0,
      loading: false,
      rules3: {
        fileList: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ]
      },
      rules2: {
        pickupQuantity: [
          { required: true, message: '请输入发货数量' },
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ],
        arrivalQuantity: [
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ]
      },
      searchForm2: {
        plateNumber: '',
        planType: '',
        ygType: '',
        reservationStatus: ''
      },
      tableData2: [],
      searchForm1: {
        plannedDate: ''
      },
      formData3: {
        fileList: []
      },
      showNumberVisible: false,
      formData2: {
        pickupQuantity: '',
        arrivalQuantity: '',
        planQuantity: '', // 这个计划数量是用来和实际数量做对比的，提交的时候需要删除
        specId: '',
        orderId: ''
      },
      info: {
        planNum: '0', // 计划产能
        yyPlanNum: '0', // 已约出货量
        yyMealNum: '0',
        yyMealNum2: '0', // 已约早餐量
        yyMealNum3: '0', // 已约午餐量
        yyMealNum4: '0' // 已约晚餐量
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasComplete() {
      return this.buttonList.includes('complete')
    },
    hasBeginZh() {
      return this.buttonList.includes('beginZh')
    },
    hasEndZh() {
      return this.buttonList.includes('endZh')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasArrival() { // 门卫签到
      return this.buttonList.includes('arrival')
    },
    hasCancel() {
      return this.buttonList.includes('cancel')
    }
  },
  watch: {
  },
  created() {
    // this.searchForm1.plannedDate = this.$dayjs().format('YYYY-MM-DD')
    // this.loadData1()
    this.loadData2()
  },
  methods: {
    changeYgTypeActive() {
      this.loadData1()
      this.loadData2()
    },
    changePlanType() {
      this.loadData1()
      this.loadData2()
    },
    checkExpired(timeslotVal) {
      const data = timeslotVal.match(/\((.*?)\)(\d{2}:\d{2})~(\d{2}:\d{2})/)
      let currentTime = this.$dayjs(this.searchForm2.plannedDate + ' ' + data[3])
      if (data[1] === '次日') {
        currentTime = currentTime.add(1, 'day')
      }
      return currentTime.isBefore(this.$dayjs())
    },
    showNumber(row) {
      console.log('当前数据', row)
      this.formData2.pickupQuantity = row.pickupQuantity || ''
      this.formData2.arrivalQuantity = row.arrivalQuantity || ''
      this.formData2.planQuantity = row.planQuantity || ''
      this.formData2.orderId = row.orderId
      this.formData2.specId = row.specId
      this.showNumberVisible = true
    },
    updatePickupQuantity() {
      this.$refs.form2.validate().then(() => {
        if (Math.abs(this.formData2.planQuantity - this.formData2.pickupQuantity) > 0.5) {
          this.$confirm('计划数量和实际数量差值超过0.5, 是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const formData2 = deepClone(this.formData2)
            delete formData2.planQuantity
            this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
              ...formData2,
              pickupId: this.currentPickupId
            }).then(res => {
              this.loadGgList(this.currentPickupId, '2')
              this.showNumberVisible = false
            })
          })
        } else {
          const formData2 = deepClone(this.formData2)
          delete formData2.planQuantity
          this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder2, {
            ...formData2,
            pickupId: this.currentPickupId
          }).then(res => {
            this.loadGgList(this.currentPickupId, '2')
            this.showNumberVisible = false
          })
        }
      })
    },
    loadGgList(planId, gGviewType = '1') {
      this.gGviewType = gGviewType
      this.currentPickupId = planId
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanGg, {
        planId
      }).then(res => {
        this.planGgList = res || []
        this.guigeVisible = true
      })
    },
    confirmComplete() {
      if (!this.planGgList.every(item => item.pickupQuantity)) {
        this.$message({
          message: '请检查规格清单，发货数量不能为空',
          type: 'warning'
        })
        return
      }
      this.formData3.fileList = []
      this.comfirmVisible = true
    },
    submitComplete() {
      this.$refs.form3.validate().then(() => {
        this.$axios.post(this.$apis.deliveryOrder.editCYWlVehiclePlanCc, {
          ...this.formData3,
          planId: this.currentPickupId
        }).then(res => {
          // this.loadGgList(this.currentPickupId, '2')
          this.loadData1()
          this.loadData2()
          this.guigeVisible = false
          this.comfirmVisible = false
        })
      })
    },
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.xcNumber && row.xcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 1 && columnIndex <= 5) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
      if (row.dcNumber && row.dcZt === '1' && this.checkExpired(row.timeslotVal) && columnIndex >= 7 && columnIndex <= 11) {
        return {
          background: '#F56C6C',
          color: '#FFFFFF'
        }
      }
    },
    confirmArrival(planId) {
      this.$confirm('确认该车辆已入场, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editMwWlVehiclePlan, {
          planId
        }).then(() => {
          this.loadData1()
          this.loadData2()
        })
      })
    },
    beginArrival(planId) {
      this.$confirm('确认开始装货, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editCYWlVehiclePlanZh, {
          planId
        }).then(() => {
          this.loadData1()
          this.loadData2()
        })
      })
    },
    endArrival(planId) {
      this.$confirm('确认装货完成, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editMwWlVehiclePlanZhWc, {
          planId
        }).then(() => {
          this.loadData1()
          this.loadData2()
        })
      })
    },
    cancelArrival(planId) {
      this.$confirm('确认取消该预约吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.editWlVehiclePlanQx, {
          planId
        }).then(() => {
          this.loadData2()
          this.loadData()
        })
      })
    },
    deleteRow(planId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.deleteDataWlVehiclePlan, {
          planId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData2() {
      this.$axios.get(this.$apis.clyy.selectWlVehiclePlanByPage, {
        ...this.searchForm2,
        page: this.page,
        size: 10
      }).then(res => {
        this.tableData2 = res.list
        this.total = res.total
      })
    },
    loadData1() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDayByList2, {
        ...this.searchForm1,
        planType: this.activeName,
        ygType: this.ygTypeActive
      }).then(res => {
        this.tableData1 = res || []
        this.loadCount()
      })
    },
    loadCount() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByPage, {
        dateDay: this.searchForm1.plannedDate,
        planType: this.activeName
      }).then(res => {
        if (res && res.list && res.list.length) {
          this.info = res.list[0]
        } else {
          this.info = {
            planNum: '0', // 计划产能
            yyPlanNum: '0', // 已约出货量
            yyMealNum: '0',
            yyMealNum2: '0', // 已约早餐量
            yyMealNum3: '0', // 已约午餐量
            yyMealNum4: '0' // 已约晚餐量
          }
        }
      })
    },
    onSearch(type) {
      if (type === '1') {
        this.page = 1
        this.loadData1()
      } else {
        this.loadData2()
      }
    },
    onReset(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.text-view {
  color: #0e6ad7;
  text-decoration: underline;
  cursor: pointer;
}

.tabs-content {
  background-color: #FFFFFF;
  margin-bottom: 20px;
  padding-left: 20px;
  border-radius: 4px;

  ::v-deep {
    .el-tabs__header {
      margin: 0;
    }
  }
}
</style>
